"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  wrap: {
    position: "x1n2onr6",
    flexGrow: "x1iyjqo2",
    minWidth: "xeuugli",
    display: "x78zum5",
    $$css: true
  },
  icon: {
    position: "x10l6tqk",
    left: "x3rwi4s",
    insetInlineStart: null,
    insetInlineEnd: null,
    top: "xwa60dl",
    transform: "x1cb1t30",
    display: "x3nfvp2",
    color: "xcdm7ny",
    pointerEvents: "x47corl",
    $$css: true
  },
  search: {
    width: "xh8yej3",
    minWidth: "xeuugli",
    boxSizing: "x9f619",
    height: "x14cnqhc",
    fontFamily: "x1wl88yq",
    fontSize: "x1jchvi3",
    color: "x10kmngs",
    backgroundColor: "xk6p4me",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc x1tz94kp",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    outline: "x1a2a7pz",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    paddingTop: "xexx8yu",
    paddingBottom: "x18d9i69",
    paddingLeft: "xe4azjs",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x36vmjb",
    transition: "x11m0sca",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    "::-webkit-search-cancel-button_appearance": "x1ad04t7",
    "::-webkit-search-cancel-button_display": "x1hcrkkg",
    $$css: true
  },
  clear: {
    position: "x10l6tqk",
    right: "xk8jqll",
    insetInlineStart: null,
    insetInlineEnd: null,
    top: "xwa60dl",
    transform: "x1cb1t30",
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "xh29eag",
    height: "xb8l8e1",
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "xjbqb8w",
    color: "xldsce3 x1qfsr1m",
    transitionProperty: "xt3l3uh",
    transitionDuration: "x13dflua x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    cursor: "x1ypdohk",
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x1y3gkto",
    $$css: true
  }
};